import {
	SET_CURRENT_SONG,
	SET_AUDIO_IS_READY,
	SET_AUDIO_QUESTION,
	SET_AUDIO_LYRICS,
	SET_AUDIO_IS_PLAYING,
	SET_AUDIO_PULSE,
	SET_AUDIO_IS_KARAOKE_MODE,
	SET_AUDIO_IS_LOOPING,
	SET_AUDIO_IS_DUCKING,
	SET_AUDIO_IS_SCRUBBING,
	SET_AUDIO_IS_AUTO_ADVANCE,
	SET_AUDIO_RATE,
	SET_AUDIO_ERROR,
} from '../actions/AppActions';
import {
	EVENT_TYPES__QUESTION,
	EVENT_TYPES__LYRIC,
	EVENT_TYPES__CLEAR,
} from '../../constants/EventTypes';
// import ExpoAV from './ExpoAV.js';
import Howler from './Howler.js';
import setPref from '../../OneHat/functions/setPref';
import {
	setQuestionById,
} from '../Thunks/setQuestion';
import _ from 'lodash';


const PlatformPlayer = Howler; // ExpoAV; // 

let errorQuestionId = null;

export default class AudioPlayer extends PlatformPlayer {

	tearDown = () => {
		this.reduxDispatch = null;
		this.reduxGetState = null;
	}

	// Decorate emit() function so we can hook into Redux dispatch()
	// These are AudioPlayer -> Redux
	async emit(name, arg) {
		const {
			currentQuestion,
			audioIsAlt,
			audioIsKaraokeMode,
		} = this.reduxGetState().App;

		switch(name) {
			case 'load': {
				const pulse = await this.getPulse();
				this.reduxDispatch({
					type: SET_AUDIO_PULSE,
					pulse,
				});
				this.reduxDispatch({
					type: SET_AUDIO_LYRICS,
					lyrics: null,
				});
				this.reduxDispatch({
					type: SET_AUDIO_IS_LOOPING,
					bool: this.isLooping,
				});
				this.reduxDispatch({
					type: SET_AUDIO_RATE,
					rate: this.rate,
				});
				this.reduxDispatch({
					type: SET_AUDIO_IS_READY,
					bool: true,
				});

				const song = audioIsKaraokeMode ? currentQuestion.getNovoxSong(audioIsAlt) : currentQuestion.getVoxSong(audioIsAlt);
				this.reduxDispatch({
					type: SET_CURRENT_SONG,
					song,
				});
				break;
			}
			case 'event':
				const event = arg;
				switch(event.type) {
					case EVENT_TYPES__QUESTION:
						this.reduxDispatch({
							type: SET_AUDIO_QUESTION,
							question: event.data,
						});
						this.reduxDispatch({
							type: SET_AUDIO_LYRICS,
							lyrics: null,
						});
						break;
					case EVENT_TYPES__LYRIC:
						this.reduxDispatch({
							type: SET_AUDIO_LYRICS,
							lyrics: event.data,
						});
						this.reduxDispatch({
							type: SET_AUDIO_QUESTION,
							question: null,
						});
						break;
					case EVENT_TYPES__CLEAR:
						this.reduxDispatch({
							type: SET_AUDIO_LYRICS,
							lyrics: null,
						});
						this.reduxDispatch({
							type: SET_AUDIO_QUESTION,
							question: null,
						});
						break;
				}
				break;
			case 'play':
				this.reduxDispatch({
					type: SET_AUDIO_IS_PLAYING,
					bool: true,
				});
				break;
			case 'pause':
			case 'end':
				this.reduxDispatch({
					type: SET_AUDIO_IS_PLAYING,
					bool: false,
				});
				break;
			case 'pulse':
				this.reduxDispatch({
					type: SET_AUDIO_PULSE,
					pulse: arg,
				});
				break;
			case 'next':
				await setQuestionById(currentQuestion.questions__next)(this.reduxDispatch, this.reduxGetState);
				break;
			case 'changeIsKaraoke':
				this.reduxDispatch({
					type: SET_AUDIO_IS_KARAOKE_MODE,
					bool: arg,
				});
				setPref('audioIsKaraokeMode', arg);
				break;
			case 'changeIsLooping':
				this.reduxDispatch({
					type: SET_AUDIO_IS_LOOPING,
					bool: arg,
				});
				
				setPref('audioIsLooping', arg);
				break;
			case 'changeIsDucking':
				this.reduxDispatch({
					type: SET_AUDIO_IS_DUCKING,
					bool: arg,
				});
				break;
			case 'changeIsScrubbing':
				this.reduxDispatch({
					type: SET_AUDIO_IS_SCRUBBING,
					bool: arg,
				});
				break;
			case 'changeIsAutoAdvance':
				this.reduxDispatch({
					type: SET_AUDIO_IS_AUTO_ADVANCE,
					bool: arg,
				});
				setPref('audioIsAutoAdvance', arg);
				break;
			case 'changeRate':
				this.reduxDispatch({
					type: SET_AUDIO_RATE,
					rate: arg,
				});
				break;
			case 'startScrubbing':
				this.reduxDispatch({
					type: SET_AUDIO_IS_SCRUBBING,
					bool: true,
				});
				this.reduxDispatch({
					type: SET_AUDIO_LYRICS,
					lyrics: null,
				});
				this.reduxDispatch({
					type: SET_AUDIO_QUESTION,
					question: null,
				});
				break;
			case 'endScrubbing':
				this.reduxDispatch({
					type: SET_AUDIO_IS_SCRUBBING,
					bool: false,
				});
				break;
			case 'error': {
				debugger;
				this.reduxDispatch({
					type: SET_AUDIO_ERROR,
					error: arg,
				});
				break;
			}
		}

		return super.emit(...arguments);
	}
}
